// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fo-0";
export var fulfillmentPanelBody = "_fo-1";